var _style, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _polygon2, _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _path5, _path6, _path7, _circle7, _path8, _path9, _path10, _path11, _path12, _rect7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bca70d0a-57dd-451b-a82c-bb6927f27458",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 798.7 647",
    style: {
      enableBackground: "new 0 0 798.7 647"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#38383D;}\n\t.st1{fill:#3F3D56;}\n\t.st2{opacity:0.3;fill:#7105FF;enable-background:new    ;}\n\t.st3{fill:#797BF2;}\n\t.st4{opacity:0.4;fill:#797BF2;enable-background:new    ;}\n\t.st5{fill:#2F2E41;}\n\t.st6{fill:#FFB8B8;}\n\t.st7{fill:#D0CDE1;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "predictive analytics") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "126.8,0 74,103 84.7,103 84.7,187 31,187 0,247.4 383.5,444 510.4,196.6 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.7,
    y: 67,
    className: "st1",
    width: 588,
    height: 295
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 198.2,
    y: 173,
    className: "st2",
    width: 434,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 198.7,
    y: 198,
    className: "st2",
    width: 434,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 198.7,
    y: 248,
    className: "st2",
    width: 434,
    height: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.7,
    y: 270,
    className: "st2",
    width: 434,
    height: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198.7,
    y: 223,
    className: "st2",
    width: 434,
    height: 1
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 566.7,
    cy: 630,
    rx: 186,
    ry: 17
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "210.7,270.7 209.3,269.3 273.9,207.7 330.9,248.7 376.9,197.6 397.1,214.8 452.1,181.8 513.1,222.8  608.8,168.4 609.8,170.1 513,225.2 452,184.2 396.9,217.2 377.1,200.4 331.2,251.3 274.1,210.3 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396.8,595.8c4.7,17.4,20.8,28.1,20.8,28.1s8.5-17.4,3.8-34.8c-4.7-17.4-20.8-28.1-20.8-28.1 S392.1,578.5,396.8,595.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M403.7,592.1c12.9,12.6,14.5,31.9,14.5,31.9s-19.3-1.1-32.2-13.6c-12.9-12.6-14.5-31.9-14.5-31.9 S390.8,579.6,403.7,592.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 765.2,
    cy: 53.5,
    r: 33.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 703.2,
    cy: 69.5,
    r: 23.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 674.2,
    cy: 500.5,
    r: 12.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 461.2,
    cy: 565.5,
    r: 9.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 429.2,
    cy: 439.5,
    r: 12.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 608.2,
    cy: 173.5,
    r: 13
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M523.7,409l-11,1.2c0,0-4.9,22,0,51.4s11,58.8,11,58.8s4.9,95.5,7.3,96.7s24.5,8.6,25.7,1.2 c1.2-7.3,1.2-175.1,1.2-175.1l17.1,80.8c0,0,2.4,101.6,7.3,101.6s20.8-1.2,20.8-9.8s3.7-121.2,3.7-121.2s-1.2-83.3-6.1-85.7 S523.7,409,523.7,409z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M533.5,613.5c0,0-11-1.2-13.5,0s-6.1,9.8,0,14.7c6.1,4.9,22,12.2,26.9,12.2c3.4-0.2,6.7-1,9.8-2.4l-2.4-20.8 L533.5,613.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M582.5,619.6l1.2,17.1c0,0,15.9,2.4,17.1,0s13.5-8.6,14.7-9.8s2.4-14.7-4.9-15.9s-9.8,2.4-9.8,2.4L582.5,619.6z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M479.6,306.1c0,0-29.4,28.2-25.7,42.9s33.1,57.6,33.1,57.6s28.2,14.7,31.8,0s-19.6-11-19.6-11l-18.4-44.1 l20.8-29.4L479.6,306.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M610.9,263.3c0,0,26.8-17.2,26.2-29s-16.8-49.1-16.8-49.1s-12.6-26.2-17.6-15.5s6.6,22.1,6.6,22.1l7.5,36.6 l-20.4,19.4L610.9,263.3z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 544.5,
    cy: 216.7,
    r: 22
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M533.5,230.2l3.7,23.3l26.9-4.9c0,0-1.2-23.3-1.2-25.7S533.5,230.2,533.5,230.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M532.3,253.5c0,0,30.6-7.3,34.3-4.9s22,4.9,22,4.9l20.8,31.8l-6.1,40.4c0,0-1.2,64.9,1.2,75.9 s15.9,12.2-12.2,14.7s-33.1-1.2-52.7,3.7s-35.5-2.4-30.6-7.3s13.5-83.3,3.7-90.6s-13.5-45.3-13.5-45.3S532.3,259.6,532.3,253.5z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M584.9,257.1l3.7-3.7l7.3-7.3c0,0,23.9,10.4,22.7,14.1s-9.2,25.1-9.2,25.1l-11,3.7L584.9,257.1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M513.9,279.2l-14.7-2.4c0,0-11,12.2-14.7,17.1s-11,17.1-11,17.1l25.7,18.4l19.6-20.8L513.9,279.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M552.2,190l-0.2-1.8c-1.5,0-3,0.2-4.4,0.7c-0.1-1.1-0.1-2.1,0.3-3.2c-1.4,0.4-2.8,1-4.1,1.8l-0.9-3.2l-12.2,6 c-4.4,2.2-9,4.5-11.5,8.8c-2.8,4.7-2.3,10.7-0.4,15.8s5.1,9.6,7.6,14.5c1,2.1,2.1,4.1,3.5,5.9c4.6,5.8,13.6,6.9,20.1,3.4 c2.5-1.2,4.5-3.2,5.6-5.7c0.5-1.6,0.8-3.1,1.1-4.8c0.8-3.3,1.7-10.1,4.4-12.2c1.2-0.9,3.5,2.1,4.5,1c2.5-2.9,2-7.4,0.4-10.9 c-1.5-3.5-3.2-6.9-5.2-10.2C559.9,194.7,552.2,189.8,552.2,190z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 115,
    className: "st1",
    width: 64,
    height: 64
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestDark);
export default __webpack_public_path__ + "static/media/test-dark.a66f9d6a81231c9ebd825184fc1e6e52.svg";
export { ForwardRef as ReactComponent };